<template>
  <div>
    <carousel
      class="move_carousel_nav"
      :paginationSize="6"
      :paginationPadding="6"
      v-model="carouselIndex"
      :perPage="1"
      :min-swipe-distance="100"
      :speed="200"
      navigation-next-label=""
      navigation-prev-label=""
      navigation-enabled
      center-mode
    >
      <slide
        v-for="(id, n) in campaignIds.filter(v => !!v)"
        :key="`${id}campaign-slide`"
        :class="{no_height: carouselIndex !== n}"
        style="overflow: hidden"
      >
        <campaign
          :key="`${id}campaign`"
          :number="n"
          :campaign-id.sync="campaignIds[n]"
          :visible="carouselIndex === n"
        />
      </slide>
    </carousel>
  </div>
</template>

<script>
import store from '../../store';
import Campaign from './Campaign.vue';
import CarouselMixin from '@/mixins/carousel_mixin';

export default {
  name: 'campaign-carousel',

  mixins: [CarouselMixin],

  components: { Campaign },

  beforeDestroy() {
    store.setCampaignCarouselIds(this.campaignIds);
    store.storeCampaignCarouselIndex(this.carouselIndex);
    store.storeScrollPosition(window.scrollY);
  },

  data() {
    return {
      campaignIds: [],
    };
  },

  created() {
    this.$bus.$on('loaded-state', () => {
      this.campaignIds = store.getCampaignCarouselIds();
    });
    this.campaignIds = store.getCampaignCarouselIds();
    this.carouselIndex = store.getCampaignCarouselIndex();
  },

  mounted() {
    window.scroll(0, store.getScrollPosition());
  },
};
</script>

<style lang="scss">
  .campaign_info{
    min-height: 206px;
  }

  .move_carousel_nav {
    .VueCarousel-pagination {
      position: absolute;
      top: 195px;
    }

    .VueCarousel-navigation-button {
      top: 99px !important;
      &.VueCarousel-navigation-next {
        right: 20px;
      }
      &.VueCarousel-navigation-prev {
        left: 20px;
      }
    }


  }
</style>
